import { createStore } from 'vuex'

import app from './modules/app'
import global from './modules/global'
import user from './modules/user'

export default createStore({
  modules: {
    app,
    global,
    user
  }
})
